import { __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
class LliService {
    constructor(http, env) {
        this.http = http;
        this.env = env;
        this.recommenderSource = new BehaviorSubject([]);
        this.shuffleArray = (array) => {
            const arrayClone = [...array];
            for (let i = arrayClone.length - 1; i > 0; i--) {
                const j = Math.floor(Math.random() * (i + 1));
                const temp = arrayClone[i];
                arrayClone[i] = arrayClone[j];
                arrayClone[j] = temp;
            }
            return arrayClone;
        };
    }
    filterRecommender(data) {
        const allArray = this.recommenderSource.value;
        const array = data.filter(item => !allArray.includes(item.externalId));
        this.recommenderSource.next([...allArray, ...array.map(item => item.externalId)]);
        return array;
    }
    formatCategories(data) {
        if (!data) {
            return;
        }
        return data.map((item) => ({
            externalId: item.externalId,
            title: item.category[0].title
        }));
    }
    getSomeRandomContent(size) {
        return __awaiter(this, void 0, void 0, function* () {
            const popularCategories = [5, 85, 13, 39, 6, 72];
            // ************************!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!******************************* //
            const randomBackup = yield this.http.get(this.env.recommenderUrl + `?categories=${getRandom(popularCategories, 3).join(',')}&algorithmType=BASE&size=${size}`).toPromise();
            const contents = this.formatRecommenderResponse(randomBackup);
            return this.sortBy(contents, 'RANDOM');
            function getRandom(arr, n) {
                // tslint:disable-next-line:prefer-const one-variable-per-declaration
                let result = new Array(n), len = arr.length, 
                // tslint:disable-next-line:prefer-const
                taken = new Array(len);
                if (n > len) {
                    throw new RangeError('getRandom: more elements taken than available');
                }
                while (n--) {
                    const x = Math.floor(Math.random() * len);
                    result[n] = arr[x in taken ? taken[x] : x];
                    taken[x] = --len in taken ? taken[len] : len;
                }
                return result;
            }
        });
    }
    isUndefinedOrEmpty(value) {
        return value !== null && value !== undefined && value.trim().length > 0;
    }
    formatRecommenderResponse(response) {
        const contents = (response === null || response === void 0 ? void 0 : response.contents) || [];
        const arri = contents.map((item) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30;
            return ({
                externalId: (_a = item.content) === null || _a === void 0 ? void 0 : _a.externalId,
                imageUrl: (_c = (_b = item.content) === null || _b === void 0 ? void 0 : _b.metadata) === null || _c === void 0 ? void 0 : _c.imageUrl,
                thumbnail: (_e = (_d = item.content) === null || _d === void 0 ? void 0 : _d.metadata) === null || _e === void 0 ? void 0 : _e.thumbnail,
                portraitImageUrl: (_g = (_f = item.content) === null || _f === void 0 ? void 0 : _f.metadata) === null || _g === void 0 ? void 0 : _g.portraitImage,
                portraitImageThumbnail: (_j = (_h = item.content) === null || _h === void 0 ? void 0 : _h.metadata) === null || _j === void 0 ? void 0 : _j.portraitImageThumbnail,
                coverThumbnailSmall: (_l = (_k = item.content) === null || _k === void 0 ? void 0 : _k.metadata) === null || _l === void 0 ? void 0 : _l.coverThumbnailSmall,
                coverThumbnailMedium: (_o = (_m = item.content) === null || _m === void 0 ? void 0 : _m.metadata) === null || _o === void 0 ? void 0 : _o.coverThumbnailMedium,
                coverThumbnailLarge: (_q = (_p = item.content) === null || _p === void 0 ? void 0 : _p.metadata) === null || _q === void 0 ? void 0 : _q.coverThumbnailLarge,
                roundImage: (_s = (_r = item.content) === null || _r === void 0 ? void 0 : _r.metadata) === null || _s === void 0 ? void 0 : _s.roundImage,
                roundImageSmall: (_u = (_t = item.content) === null || _t === void 0 ? void 0 : _t.metadata) === null || _u === void 0 ? void 0 : _u.roundImageSmall,
                roundImageMedium: (_w = (_v = item.content) === null || _v === void 0 ? void 0 : _v.metadata) === null || _w === void 0 ? void 0 : _w.roundImageMedium,
                roundImageLarge: (_y = (_x = item.content) === null || _x === void 0 ? void 0 : _x.metadata) === null || _y === void 0 ? void 0 : _y.roundImageLarge,
                roundImageRetina: (_0 = (_z = item.content) === null || _z === void 0 ? void 0 : _z.metadata) === null || _0 === void 0 ? void 0 : _0.roundImageRetina,
                roundImageMediumRetina: (_2 = (_1 = item.content) === null || _1 === void 0 ? void 0 : _1.metadata) === null || _2 === void 0 ? void 0 : _2.roundImageMediumRetina,
                roundImageSmallRetina: (_4 = (_3 = item.content) === null || _3 === void 0 ? void 0 : _3.metadata) === null || _4 === void 0 ? void 0 : _4.roundImageSmallRetina,
                mediumImg: (_6 = (_5 = item.content) === null || _5 === void 0 ? void 0 : _5.metadata) === null || _6 === void 0 ? void 0 : _6.mediumImg,
                imageAlt: (_8 = (_7 = item.content) === null || _7 === void 0 ? void 0 : _7.metadata) === null || _8 === void 0 ? void 0 : _8.imageAlt,
                hasVideo: this.isUndefinedOrEmpty((_10 = (_9 = item.content) === null || _9 === void 0 ? void 0 : _9.metadata) === null || _10 === void 0 ? void 0 : _10.vimeoId),
                title: (_13 = (_12 = (_11 = item.content) === null || _11 === void 0 ? void 0 : _11.content) === null || _12 === void 0 ? void 0 : _12[0]) === null || _13 === void 0 ? void 0 : _13.title,
                description: (_16 = (_15 = (_14 = item.content) === null || _14 === void 0 ? void 0 : _14.content) === null || _15 === void 0 ? void 0 : _15[0]) === null || _16 === void 0 ? void 0 : _16.description,
                tag: (_20 = (_19 = (_18 = (_17 = item.content) === null || _17 === void 0 ? void 0 : _17.content) === null || _18 === void 0 ? void 0 : _18[0]) === null || _19 === void 0 ? void 0 : _19.tags) === null || _20 === void 0 ? void 0 : _20[0],
                url: (_21 = item.content) === null || _21 === void 0 ? void 0 : _21.url,
                publishDate: (_23 = (_22 = item.content) === null || _22 === void 0 ? void 0 : _22.metadata) === null || _23 === void 0 ? void 0 : _23.publishDate,
                categories: item.content && this.formatCategories((_24 = item.content) === null || _24 === void 0 ? void 0 : _24.categories),
                showDate: (_26 = (_25 = item.content) === null || _25 === void 0 ? void 0 : _25.metadata) === null || _26 === void 0 ? void 0 : _26.showDate,
                contactEMail: (_28 = (_27 = item.content) === null || _27 === void 0 ? void 0 : _27.metadata) === null || _28 === void 0 ? void 0 : _28.contactEMail,
                showEMail: (_30 = (_29 = item.content) === null || _29 === void 0 ? void 0 : _29.metadata) === null || _30 === void 0 ? void 0 : _30.showEMail,
            });
        }).filter((item) => (item === null || item === void 0 ? void 0 : item.title) && (item === null || item === void 0 ? void 0 : item.url) && (item === null || item === void 0 ? void 0 : item.imageUrl));
        return arri;
    }
    sortBy(data, sortBy) {
        if (sortBy === 'BY_DATE') {
            return data.sort((a, b) => {
                const dateA = new Date(a.publishDate.replace(/\s/, 'T'));
                const dateB = new Date(b.publishDate.replace(/\s/, 'T'));
                // @ts-ignore
                return dateB.getTime() - dateA.getTime();
            });
        }
        if (sortBy === 'RANDOM') {
            return this.shuffleArray(data);
        }
        return data;
    }
    getCollection(options) {
        console.log('getCollection');
        return this.http.post(this.env.searchURL, options).pipe(map((data) => ({
            contents: this.formatSearchResponse(data),
            searchTermRecommendations: this.formatCategories(data.searchtermRecommendations),
            paging: data.paging,
            facets: data.facets
        })));
    }
    getCollectionCustom(options) {
        console.log('getCollectionCustom');
        return this.http.post(this.env.collectionCustomUrl, options).pipe(map((data) => ({
            contents: this.formatSearchResponse(data),
            searchTermRecommendations: this.formatCategories(data.searchtermRecommendations),
            paging: data.paging,
            facets: data.facets
        })));
    }
    formatSearchResponse({ contents = [] }) {
        console.log('formatSearchResponse:');
        return contents.map((item) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1;
            return ({
                externalId: item === null || item === void 0 ? void 0 : item.externalId,
                imageUrl: (_a = item.metadata) === null || _a === void 0 ? void 0 : _a.imageUrl,
                thumbnail: (_b = item.metadata) === null || _b === void 0 ? void 0 : _b.thumbnail,
                mediumImg: (_c = item.metadata) === null || _c === void 0 ? void 0 : _c.mediumImg,
                coverThumbnailSmall: (_d = item.metadata) === null || _d === void 0 ? void 0 : _d.coverThumbnailSmall,
                coverThumbnailMedium: (_e = item.metadata) === null || _e === void 0 ? void 0 : _e.coverThumbnailMedium,
                roundImage: (_f = item.metadata) === null || _f === void 0 ? void 0 : _f.roundImage,
                roundImageSmall: (_g = item.metadata) === null || _g === void 0 ? void 0 : _g.roundImageSmall,
                roundImageMedium: (_h = item.metadata) === null || _h === void 0 ? void 0 : _h.roundImageMedium,
                roundImageLarge: (_j = item.metadata) === null || _j === void 0 ? void 0 : _j.roundImageLarge,
                roundImageRetina: (_k = item.metadata) === null || _k === void 0 ? void 0 : _k.roundImageRetina,
                roundImageRetinaMedium: (_l = item.metadata) === null || _l === void 0 ? void 0 : _l.roundImageRetinaMedium,
                roundImageRetinaSmall: (_m = item.metadata) === null || _m === void 0 ? void 0 : _m.roundImageRetinaSmall,
                hasVideo: this.isUndefinedOrEmpty((_o = item.metadata) === null || _o === void 0 ? void 0 : _o.vimeoId),
                imageAlt: (_p = item.metadata) === null || _p === void 0 ? void 0 : _p.imageAlt,
                title: (_r = (_q = item.content) === null || _q === void 0 ? void 0 : _q[0]) === null || _r === void 0 ? void 0 : _r.title,
                description: (_t = (_s = item.content) === null || _s === void 0 ? void 0 : _s[0]) === null || _t === void 0 ? void 0 : _t.description,
                tag: (_w = (_v = (_u = item.content) === null || _u === void 0 ? void 0 : _u[0]) === null || _v === void 0 ? void 0 : _v.tags) === null || _w === void 0 ? void 0 : _w[0],
                url: item === null || item === void 0 ? void 0 : item.url,
                type: item === null || item === void 0 ? void 0 : item.type,
                publishDate: (_x = item.metadata) === null || _x === void 0 ? void 0 : _x.publishDate,
                categories: item.content && this.formatCategories((_y = item.content) === null || _y === void 0 ? void 0 : _y.categories),
                showDate: (_z = item.metadata) === null || _z === void 0 ? void 0 : _z.showDate,
                contactEMail: (_0 = item.metadata) === null || _0 === void 0 ? void 0 : _0.contactEMail,
                showEMail: (_1 = item.metadata) === null || _1 === void 0 ? void 0 : _1.showEMail,
            });
        });
    }
}
LliService.ɵfac = function LliService_Factory(t) { return new (t || LliService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject('env')); };
LliService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LliService_Factory() { return new LliService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject("env")); }, token: LliService, providedIn: "root" });
LliService.ctorParameters = () => [
    { type: HttpClient },
    { type: undefined, decorators: [{ type: Inject, args: ['env',] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LliService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: undefined, decorators: [{
                type: Inject,
                args: ['env']
            }] }]; }, null); })();

var algorithmType;
(function (algorithmType) {
    algorithmType["BASE"] = "BASE";
    algorithmType["V2"] = "V2";
    algorithmType["V3"] = "V3";
    algorithmType["minus1"] = "-1";
    algorithmType["LIVE"] = "LIVE";
})(algorithmType || (algorithmType = {}));
class Category {
}
class Content {
}
class SearchTermRecommendations {
}
class LimitedChannels {
}
class SubscriptionPath {
}
class StaticContent {
}
class RecommenderData {
}

class LliModule {
    static forRoot(environment) {
        return {
            ngModule: LliModule,
            providers: [
                LliService,
                {
                    provide: 'env',
                    useValue: environment
                }
            ]
        };
    }
}
LliModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: LliModule });
LliModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function LliModule_Factory(t) { return new (t || LliModule)(); }, imports: [[]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LliModule, [{
        type: NgModule,
        args: [{
                declarations: [],
                imports: [],
                exports: []
            }]
    }], null, null); })();

/*
 * Public API Surface of lli
 */

/**
 * Generated bundle index. Do not edit.
 */

export { Category, Content, LimitedChannels, LliModule, LliService, RecommenderData, SearchTermRecommendations, StaticContent, SubscriptionPath, algorithmType };

//# sourceMappingURL=scoop-lli-lli.js.map